import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MatchedMail } from '../intefaces/matched-mail.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MatchedMailService {
  private readonly headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders().set('Authorization', 'Bearer Gustav');
  }

  /**
   * Get all matched mails for a given infringement identifier.
   */
  getMatchedMails(identifier: string): Observable<MatchedMail[]> {
    const params = new HttpParams()
      .set('resource', 'matchedmail')
      .set('identifier', identifier);
    const headers = this.headers;
    return this.http.get<MatchedMail[]>(environment.apiUrl, { headers, params });
  }

  /**
   * Acknowledge (dismiss notification) a matched mail entry.
   */
  acknowledgeMail(identifier: string, messageId: string): Observable<MatchedMail> {
    const params = new HttpParams().set('resource', 'matchedmailacknowledge');
    const headers = this.headers;
    const body = { identifier, message_id: messageId };
    return this.http.post<MatchedMail>(environment.apiUrl, body, { headers, params });
  }

  /**
   * Manually trigger the mail matcher to scan for new matches.
   */
  triggerMailMatching(): Observable<{ triggered: boolean; function: string }> {
    const params = new HttpParams().set('resource', 'mailmatchertrigger');
    const headers = this.headers;
    return this.http.post<{ triggered: boolean; function: string }>(environment.apiUrl, {}, { headers, params });
  }
}
